var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"point-cloud-container",attrs:{"id":_vm.mapId}},[(_vm.loading)?_c('div',{staticClass:"pc-status"},[_c('b-spinner',{staticClass:"mr-2",attrs:{"small":""}}),_vm._v(_vm._s(_vm.loadingLabel)+" ")],1):_vm._e(),(_vm.error)?_c('div',{staticClass:"pc-status pc-status-error"},[_vm._v(_vm._s(_vm.error))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }